import app from './app';

async function main() {
  app.$mount('#app');
}

main();
